import { ref, onMounted, onUnmounted } from "vue";
import { getPerformanceStatus } from "@/utils/obs";

const DEFAULT_POLL_MS = 5 * 60 * 1000;

export function usePerformanceStatus(pollInterval = DEFAULT_POLL_MS) {
  const status = ref(null);
  const loading = ref(false);

  async function fetchPerformanceStatus() {
    try {
      loading.value = true;
      status.value = await getPerformanceStatus();
    } catch {
      status.value = null;
    } finally {
      loading.value = false;
    }
  }

  let intervalId;

  onMounted(() => {
    fetchPerformanceStatus();
    intervalId = setInterval(fetchPerformanceStatus, pollInterval);
  });

  onUnmounted(() => {
    if (intervalId) {
      clearInterval(intervalId);
    }
  });

  return { status, loading, fetchPerformanceStatus };
}
